import React, { useState, useEffect } from "react";
import "./ChildProviderConsentModal.css";
import { structuredOptionalConsents } from "../../legal/consentStructure";

export default function ChildProviderConsentModal({
  visible,
  onCancel,
  onProceed,
  currentConsents = [],
  haveMultichild = false,
  loading = false,
}) {
  const targetGroup = structuredOptionalConsents.find((group) =>
    group.items.some((item) => item.id === "opt_provider_share")
  );
  const consentItems = targetGroup ? targetGroup.items : [];

  const [checks, setChecks] = useState({});
  const [applyAllChild, setApplyAllChild] = useState(false);

  useEffect(() => {
    if (visible) {
      const initialChecks = {};
      consentItems.forEach((item) => {
        initialChecks[item.id] = currentConsents.includes(item.id);
      });
      setChecks(initialChecks);
      setApplyAllChild(false);
    }
  }, [visible, currentConsents]);

  const toggleCheck = (id) => {
    if (loading) return;
    setChecks((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const isPrimaryConsentSelected = !!checks["opt_provider_share"];

  if (!visible) return null;

  return (
    <div className="consent-modal-overlay">
      <div className="consent-modal-content">
        <h2 className="consent-modal-title">
          {targetGroup?.heading || "Share developmental record"}
        </h2>

        <div className="consent-context-box">
          <p className="consent-context-text">
            To connect your child to a provider (health worker or pediatrician), you must accept the primary sharing consent below.
          </p>
        </div>

        {consentItems.map((item) => {
          const isChecked = !!checks[item.id];
          const isRequired = item.id === "opt_provider_share";

          return (
            <div
              key={item.id}
              className={`consent-chk-row ${isChecked ? "checked" : ""}`}
              onClick={() => toggleCheck(item.id)}
            >
              <div className={`consent-checkbox ${isChecked ? "checked" : ""}`}>
                {isChecked && (
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                )}
              </div>
              <div className="consent-text-container">
                <div className="consent-title-row">
                  <span className="consent-chk-title">{item.title}</span>
                  <span className={`consent-pill ${isRequired ? "req" : "opt"}`}>
                    {isRequired ? "REQUIRED" : "OPTIONAL"}
                  </span>
                </div>
                {item.desc && <span className="consent-chk-desc">{item.desc}</span>}
              </div>
            </div>
          );
        })}

        {haveMultichild && (
          <div
            className={`consent-chk-row multi-child ${applyAllChild ? "checked" : ""}`}
            onClick={() => !loading && setApplyAllChild(!applyAllChild)}
          >
            <div className={`consent-checkbox multi-child ${applyAllChild ? "checked" : ""}`}>
              {applyAllChild && (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              )}
            </div>
            <div className="consent-text-container">
              <div className="consent-title-row">
                <span className="consent-chk-title" style={{ color: "#2E75B6" }}>
                  Apply these updates to all my children
                </span>
              </div>
              <span className="consent-chk-desc">
                Enabling this automatically updates preferences for all child profiles linked to your account.
              </span>
            </div>
          </div>
        )}

        <div className="consent-btn-container">
          <button
            className="consent-btn cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="consent-btn submit"
            onClick={() => onProceed(checks, applyAllChild)}
            disabled={!isPrimaryConsentSelected || loading}
          >
            {loading ? <div className="consent-spinner"></div> : "OK"}
          </button>
        </div>
      </div>
    </div>
  );
}